import { render, staticRenderFns } from "./WaitingIndicator.vue?vue&type=template&id=66878b54&scoped=true&"
import script from "./WaitingIndicator.vue?vue&type=script&lang=js&"
export * from "./WaitingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./WaitingIndicator.vue?vue&type=style&index=0&id=66878b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66878b54",
  null
  
)

export default component.exports